/* eslint-disable no-underscore-dangle */
import React, { useEffect, useRef, useState } from 'react';
import BiddingItemImminence from 'components/molecules/bidding_item_imminence';
import SelectButton from 'components/atoms/select_button';
import ItemTools from 'components/molecules/item_tools';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ImminenceState, ImminenceTypes } from 'store/modules/get_dados_imminence_store/types';
import EmptyResult from 'components/atoms/empty_result';
import Loader from 'components/atoms/loader';
import { getDownloadImminance } from 'services/actions/bidding_actions';
import ItemShare from 'components/atoms/item_share';
import Pagination from 'components/atoms/pagination';
import { toggleSelected } from 'services/toggleSelected';
import { useReactToPrint } from 'react-to-print';
import { Container } from './styles';

interface BiddingImminenceListProps {
  setPage: React.Dispatch<React.SetStateAction<number>>;
  page: number;
}

const BiddingImminenceList = (props: BiddingImminenceListProps) => {
  const { setPage, page } = props;

  const dispatch = useDispatch();
  const [selectedBiddings, setSelectedBiddings] = useState<Array<number>>([]);
  const componentRef = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [showShareWindow, setShowShareWindow] = useState<boolean>(false);
  const [wholePageSelected, setWholePageSelected] = useState<boolean>(false);
  const [scrollToolsClass, setScrollToolsClass] = useState<string>('');

  const { get_imminence, request } = useSelector<ApplicationState, ImminenceState>(
    (state) => state.session.get_imminence,
  );
  const toggleSelectedBiddings = (id: number, updateAll = false) => {
    toggleSelected({
      id,
      updateAll,
      selectedList: selectedBiddings,
      setSelectedList: setSelectedBiddings,
      sourceList: get_imminence?._source,
      wholePageSelected,
    });
  };

  useEffect(() => {
    if (!get_imminence?._source) return;

    setWholePageSelected(
      get_imminence?._source
        ?.map((bidding) => bidding?._source?.id)
        .filter((bidding) => selectedBiddings.includes(bidding))?.length ===
        get_imminence?._source?.length,
    );
  }, [
    selectedBiddings,
    get_imminence.currentPage,
    get_imminence.postsPerPage,
    get_imminence?._source,
  ]);

  useEffect(() => {
    const windowDiv = document.getElementById('windowDiv');
    windowDiv?.addEventListener('scroll', () => {
      setScrollToolsClass(windowDiv?.scrollTop > 100 ? 'border-bottom' : '');
    });
  }, []);

  const downloadFile = (fileExtension: string) => {
    getDownloadImminance(
      fileExtension,
      'iminencia',
      selectedBiddings,
      selectedBiddings.length,
      false,
    );
  };

  const handleShare = () => {
    setShowShareWindow(!showShareWindow);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'conlicitacao',
  });

  const updateCurrentPage = (currentPage = 1) => {
    dispatch({ type: ImminenceTypes.UPDATE_CURRENT_PAGE, currentPage });
    setPage(currentPage);
    document.querySelector('#windowDiv')?.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <Container className="d-print-none">
      <div className={`row list-tools py-1 ${scrollToolsClass}`}>
        <div className="position-relative col-lg-6 d-block py-3 px-2">
          <SelectButton
            isChecked={wholePageSelected}
            id={0}
            toggleSelected={toggleSelectedBiddings}
            text="Selecionar página"
          />
          {selectedBiddings.length > 0 && (
            <div className="itemToolsSelected ml-3">
              {selectedBiddings.length}{' '}
              {selectedBiddings.length === 1 ? 'registro selecionado.' : 'registros selecionados.'}
              <button
                type="button"
                className="btn btn-link m-0 py-0 px-1 border-0"
                onClick={() => setSelectedBiddings([])}
              >
                Limpar seleção.
              </button>
            </div>
          )}
        </div>
        <ItemTools
          enabledButtons={selectedBiddings?.length > 0}
          disabledPopoverLabel="a licitação"
          downloadFile={downloadFile}
          handleShare={handleShare}
          handlePrint={handlePrint}
        />
        {showShareWindow && (
          <ItemShare setShowShareWindow={setShowShareWindow} selectedItems={selectedBiddings} />
        )}
      </div>
      {request.loading && (
        <div className="d-flex align-items-center justify-content-center loading-container">
          <Loader />
        </div>
      )}
      <div ref={componentRef} className="row mx-auto mt-5">
        <div className="col-12">
          {request.loaded &&
            get_imminence?._source?.map((bidding, index) => (
              <BiddingItemImminence
                key={bidding?._source?.id}
                biddingImminence={bidding}
                biddingIndex={index + (page - 1) * get_imminence.postsPerPage}
                toggleSelectedBiddings={toggleSelectedBiddings}
                isChecked={selectedBiddings.includes(bidding?._source?.id)}
              />
            ))}
        </div>
      </div>
      {request.loaded && get_imminence?._source?.length === 0 && (
        <EmptyResult
          title="Desculpe!"
          description="Não temos licitações que correspondam a esses filtros."
        />
      )}
      {request.loaded && get_imminence.total_entries !== 0 && (
        <div className="row d-print-none">
          <div className="col-md-12 px-3 mb-5 pb-5">
            <Pagination
              postsPerPage={get_imminence?.postsPerPage}
              totalPosts={get_imminence?.total_entries}
              paginate={updateCurrentPage}
              currentPage={page}
              firstAndLastPage
            />
          </div>
        </div>
      )}
    </Container>
  );
};

export default BiddingImminenceList;
